export enum EntityName {
    Target = 'targets',
    FormSchema = 'form-schemas',
    TargetParam = 'target-params',
}
